var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSieveLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 981,
    height: 160,
    viewBox: "0 0 981 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.33 4.32422H76.7603V8.05422H76.8903C97.9203 8.05422 112.36 27.1442 114.18 48.4242L114.64 53.6942L118.28 53.5842L115.33 4.33422V4.32422Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33023 4.32422L0.490234 53.5742L4.24023 53.6842L4.47023 48.3042C5.38023 27.1342 20.6202 8.05422 41.6502 8.05422H43.1302V154.154H37.2102V157.884H67.2402V4.32422H3.33023Z",
    fill: "#131313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.89 8.05422H170.01V4.32422H132.94V8.05422H138.28V154.154H132.94V157.884H170.01V154.154H164.89V82.4142H207.64V78.6942H164.89V8.05422Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.411 4.32422V4.65422V78.6942H239.821V8.05422V4.32422H212.411Z",
    fill: "#131313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.411 82.4143V84.3543V157.884H239.821V154.154V82.4143H212.411Z",
    fill: "#131313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M332.37 106.334H336.01V54.4443H332.37C331.12 69.9043 324.98 73.0943 309.97 77.2643C307.06 78.0543 303.32 78.4243 300.29 78.5743V82.4143C303.29 82.5643 307.08 82.8743 309.86 83.5043C323.73 86.5743 331.23 90.7443 332.37 106.324V106.334Z",
    fill: "#131313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.28 6.48422V8.12422C348.03 8.85422 353.53 29.0242 354.53 47.7642L354.87 54.2342L358.51 54.0142L355.9 4.32422H300.28V6.48422Z",
    fill: "#131313"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.35 82.4143V154.154H258V157.884H290.76V82.4143H263.35Z",
    fill: "#131313"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.27 106.764L356.93 112.904C355.8 133.464 348.46 154.004 300.28 154.134V157.874H357.84L361.25 106.874L357.27 106.764Z",
    fill: "#131313"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.35 78.6942H290.76V4.32422H258V8.05422H263.35V78.6942Z",
    fill: "#131313"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M677.85 106.334H681.49V54.4443H677.85C676.6 69.9043 670.461 73.0943 655.451 77.2643C652.541 78.0543 648.811 78.4243 645.771 78.5743V82.4143C648.771 82.5643 652.56 82.8743 655.34 83.5043C669.21 86.5743 676.72 90.7443 677.85 106.324V106.334Z",
    fill: "#131313"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M645.771 6.48422V8.12422C693.521 8.85422 699.011 29.0242 700.021 47.7642L700.36 54.2342L704 54.0142L701.391 4.32422H645.78V6.48422H645.771Z",
    fill: "#131313"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M608.831 82.4143V154.154H603.48V157.884H636.24V82.4143H608.831Z",
    fill: "#131313"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M608.831 78.6942H636.24V4.32422H603.48V8.05422H608.831V78.6942Z",
    fill: "#131313"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M702.75 106.764L702.41 112.904C701.28 133.454 693.941 154.004 645.771 154.134V157.874H703.32L706.73 106.874L702.75 106.764Z",
    fill: "#131313"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M919.521 6.48422V8.12422C967.291 8.84422 972.79 29.0242 973.79 47.7642L974.13 54.2342L977.771 54.0142L975.16 4.32422H919.521V6.48422Z",
    fill: "#131313"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M951.63 106.334H955.27V54.4443H951.63C950.38 69.9043 944.24 73.0943 929.23 77.2643C926.31 78.0643 922.57 78.4243 919.53 78.5843V82.4243C922.53 82.5643 926.34 82.8843 929.12 83.5143C942.99 86.5843 950.49 90.7543 951.63 106.334Z",
    fill: "#131313"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M882.61 82.4143V154.154H877.26V157.884H909.99V82.4143H882.61Z",
    fill: "#131313"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M882.61 78.6942H909.99V4.32422H877.26V8.05422H882.61V78.6942Z",
    fill: "#131313"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M976.53 106.764L976.19 112.904C975.06 133.464 967.72 154.014 919.53 154.134V157.874H977.1L980.51 106.874L976.53 106.764Z",
    fill: "#131313"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M547.83 4.32422V8.05422H553.18V154.154H547.83V157.884H579.58V4.32422H547.83Z",
    fill: "#131313"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M592.15 108.964C592.15 108.704 592.12 108.474 592.11 108.214C592.11 108.534 592.14 108.844 592.14 109.164C592.14 109.094 592.15 109.034 592.15 108.964Z",
    fill: "#131313"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M445.721 35.3343C442.011 31.4543 441.87 27.4843 441.87 22.1443C441.87 10.8243 446.421 3.7843 466.881 3.7843C502.581 3.7843 516.8 27.0643 523.17 61.4443L526.92 61.3343L523.62 10.8343H520.21C515.44 18.7343 507.09 10.2543 500.55 7.0043C487.04 0.294297 484.17 0.154297 467.8 0.154297C451.43 0.154297 442.97 5.1143 433.59 13.1043C432.59 18.8043 433.5 26.6343 445.73 35.3343H445.721Z",
    fill: "#131313"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M430.57 15.9243C429.68 28.2543 428.04 48.3143 474.77 61.9443C506.51 71.2943 531.16 81.3843 530.1 110.214C529.67 121.714 529.82 131.474 522.22 139.174C523.06 126.844 513.46 101.454 467.24 87.8343C435.66 78.4343 418.11 64.4543 418.14 44.4443C418.15 37.0743 419.29 28.4943 430.58 15.9243H430.57Z",
    fill: "#131313"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M498.99 117.244C502.6 121.294 504.29 126.214 504.29 132.554C504.29 146.754 491.56 153.804 472.68 153.804C439.82 153.804 427.09 132.124 420.61 93.4844L416.74 93.6944L420.15 146.764H423.67C428.54 143.794 442.87 148.314 444.28 149.334C445.9 150.504 448.73 156.074 473.58 157.754C491.18 158.944 507.64 152.034 519.21 142.014C520.27 135.764 516.38 126.954 498.98 117.244H498.99Z",
    fill: "#131313"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M812.87 4.32422V8.05422H813.44C823.9 8.05422 826.74 19.5742 826.74 41.9442C826.74 47.8442 825.71 54.4642 823.44 61.7842L827.2 63.6642C838.46 35.6942 848.46 8.05422 859.61 8.05422H859.95V4.32422H812.88H812.87Z",
    fill: "#131313"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M802.25 125.814L800.02 121.244L751.93 8.05422H755.91V4.32422H717.7V8.05422H719.97L786.72 159.414H788.77L802.25 125.814Z",
    fill: "#131313"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSieveLogoBlack);
export default __webpack_public_path__ + "static/media/Sieve-logo-black.524aea0f312d724de646b60901b3fdfe.svg";
export { ForwardRef as ReactComponent };